// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Address from "./address.js"

const modelClassData = {
  "attributes": {
    "address_id": {
      "column": {
        "default": null,
        "name": "address_id",
        "null": false,
        "type": "uuid"
      },
      "name": "address_id",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "email": {
      "column": {
        "default": null,
        "name": "email",
        "null": true,
        "type": "string"
      },
      "name": "email",
      "selected_by_default": null,
      "translated": null
    },
    "name": {
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      },
      "name": "name",
      "selected_by_default": null,
      "translated": null
    },
    "phone_number": {
      "column": {
        "default": null,
        "name": "phone_number",
        "null": true,
        "type": "string"
      },
      "name": "phone_number",
      "selected_by_default": null,
      "translated": null
    },
    "vat_number": {
      "column": {
        "default": null,
        "name": "vat_number",
        "null": true,
        "type": "string"
      },
      "name": "vat_number",
      "selected_by_default": null,
      "translated": null
    },
    "sender_email": {
      "column": {
        "default": null,
        "name": "sender_email",
        "null": true,
        "type": "string"
      },
      "name": "sender_email",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "TenantContactSetting",
  "collectionKey": "tenant_contact_settings",
  "collectionName": "tenant_contact_settings",
  "i18nKey": "tenant_contact_setting",
  "camelizedLower": "tenantContactSetting",
  "name": "TenantContactSetting",
  "nameDasherized": "tenant-contact-setting",
  "pluralName": "tenant_contact_settings",
  "ransackable_associations": [
    {
      "className": "Address",
      "collectionName": "addresses",
      "foreignKey": "address_id",
      "name": "address",
      "macro": "belongs_to",
      "resource_name": "Address",
      "through": null
    },
    {
      "className": "Log",
      "collectionName": "logs",
      "foreignKey": "trackable_id",
      "name": "logs",
      "macro": "has_many",
      "resource_name": "Log",
      "through": null
    },
    {
      "className": "Tagging",
      "collectionName": "taggings",
      "foreignKey": "resource_id",
      "name": "taggings",
      "macro": "has_many",
      "resource_name": "Tagging",
      "through": null
    },
    {
      "className": "Tag",
      "collectionName": "tags",
      "foreignKey": "tag_id",
      "name": "tags",
      "macro": "has_many",
      "resource_name": "Tag",
      "through": "taggings"
    },
    {
      "className": "Tenant",
      "collectionName": "tenants",
      "foreignKey": "tenant_id",
      "name": "tenant",
      "macro": "belongs_to",
      "resource_name": "Tenant",
      "through": null
    },
    {
      "className": "WorkerPlugins::WorkplaceLink",
      "collectionName": "workplace_links",
      "foreignKey": "resource_id",
      "name": "workplace_links",
      "macro": "has_many",
      "resource_name": "WorkplaceLink",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "address_id",
      "column": {
        "default": null,
        "name": "address_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "email",
      "column": {
        "default": null,
        "name": "email",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "id_string",
      "column": null
    },
    {
      "name": "name",
      "column": {
        "default": null,
        "name": "name",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "phone_number",
      "column": {
        "default": null,
        "name": "phone_number",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "sender_email",
      "column": {
        "default": null,
        "name": "sender_email",
        "null": true,
        "type": "string"
      }
    },
    {
      "name": "tenant_id",
      "column": {
        "default": null,
        "name": "tenant_id",
        "null": false,
        "type": "uuid"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "vat_number",
      "column": {
        "default": null,
        "name": "vat_number",
        "null": true,
        "type": "string"
      }
    }
  ],
  "ransackable_scopes": [
    {
      "name": "in_current_workplace"
    },
    {
      "name": "soft_deleted_filter"
    },
    {
      "name": "sort_by_in_current_workplace_asc"
    },
    {
      "name": "sort_by_in_current_workplace_desc"
    }
  ],
  "relationships": [
    {
      "className": "Address",
      "collectionName": "addresses",
      "foreignKey": "address_id",
      "name": "address",
      "macro": "belongs_to",
      "resource_name": "Address",
      "through": null
    }
  ],
  "paramKey": "tenant_contact_setting",
  "primaryKey": "id"
}

/** Frontend model for TenantContactSetting. */
export default class TenantContactSetting extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  addressId() {
    return this.readAttributeUnderscore("address_id")
  }

  /** @returns {boolean} */
  hasAddressId() {
    const value = this.addressId()

    return this._isPresent(value)
  }

  /** @returns {string} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  email() {
    return this.readAttributeUnderscore("email")
  }

  /** @returns {boolean} */
  hasEmail() {
    const value = this.email()

    return this._isPresent(value)
  }

  /** @returns {string} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  phoneNumber() {
    return this.readAttributeUnderscore("phone_number")
  }

  /** @returns {boolean} */
  hasPhoneNumber() {
    const value = this.phoneNumber()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  vatNumber() {
    return this.readAttributeUnderscore("vat_number")
  }

  /** @returns {boolean} */
  hasVatNumber() {
    const value = this.vatNumber()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  senderEmail() {
    return this.readAttributeUnderscore("sender_email")
  }

  /** @returns {boolean} */
  hasSenderEmail() {
    const value = this.senderEmail()

    return this._isPresent(value)
  }

  /** @returns {import("./address.js").default | null} */
  address() {
    return this._readBelongsToReflection({modelClass: Address, reflectionName: "address"})
  }

  /** @returns {Promise<import("./address.js").default | null>} */
  loadAddress() {
    if (!("addressId" in this)) throw new Error("Foreign key method wasn't defined: addressId")

    const id = this.addressId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "address",
        model: this,
        modelClass: Address
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./address.js").default | null>} */
  ensureAddressLoaded() {
    return this.ensureAssociationLoaded("address")
  }
}
